import { CardPreviewTileRender } from "./card-preview-tile-render";
import type { DetectedLinksMap } from "../../../core/sns-detector";
import { snsPreviewManagerForm } from "../../sns-preview-manager-form";

export class SnsCardPreviewFirstTileRender {
    public static addFirstSnsTilePreviewToCard(
        cardElement: Element,
        normalizedSnsLinks: string[],
        detectedLinks: DetectedLinksMap,
    ): void {
        if (!(cardElement instanceof HTMLElement)) return;

        const boardMediaArea = snsPreviewManagerForm.getBoardMediaArea(cardElement);
        if (!(boardMediaArea instanceof HTMLElement)) return;

        const placeholder = snsPreviewManagerForm.getBoardMediaPlaceholder(boardMediaArea);
        if (!placeholder) return;

        const existing = snsPreviewManagerForm.getExistingPrimaryPreview(boardMediaArea);
        if (existing) return;

        let url = Array.isArray(normalizedSnsLinks) && normalizedSnsLinks.length ? normalizedSnsLinks[0] : "";
        if (!url) {
            const platforms = Object.keys(detectedLinks || {});
            for (const platform of platforms) {
                const items = detectedLinks[platform];
                if (!Array.isArray(items) || !items.length) continue;
                url = String(items[0]?.url || "");
                if (url) break;
            }
        }

        if (!url) return;

        placeholder.remove();
        CardPreviewTileRender.renderIndexSnsTilePreview(boardMediaArea, url);
    }
}
